export default class DocumentPreviewData {
    public documentId: number;
    public base64: string = '';

    constructor(
        documentId: number,
        base64: string,
    ) {
        this.documentId = documentId;

        if (base64 !== null) {
            this.base64 = base64;
        }
    }

    get imageSource() {
        if (this.base64 === '') {
            return 'image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';
        }

        return 'data:image/jpeg;base64, ' + this.base64;
    }

    get hasData() {
        return (
            this.base64 !== ''
        );
    }
}
